import { ServiceType } from '@/enums/services'
import {
  COMPANY_NOTIFICATIONS,
  COUNTRY_ID,
  PERMISSIONS,
  SETTINGS_TABS,
} from '@/enums/settings'
import { ROUTE_PATHS } from '@/router/paths'
import { Component, Ref } from 'vue'
import { AddressProfile } from './address.model'
import { StringDateTime } from './shared.model'

export interface PaymentCompany {
  id?: number
  reg_country: COUNTRY_ID | null
}

export interface SettingsGeneral {
  lorem_ipsum: boolean
}

export interface SettingsProfile {
  name: string | null
  reg_country: string | null | Country
  reg_code: string | null
  vat_number: string | null
  phone: string | null
  email: string | null
  language: string | null
  description: string | null
  visit_estonia: boolean
  booking_com: boolean
  airbnb: boolean
  address: AddressProfile
  facebook: string | null
  instagram: string | null
  twitter: string | null
  linkedin: string | null
  is_agreed_contract: boolean
  color_preferences: ColorPreferences | null
  payment: {
    beneficiary_name: string
    iban: string | undefined
    reference_number: string | undefined
    company: PaymentCompany
    beneficial_owners: BeneficialOwner[]
  }
}

export interface Country {
  readonly id: number
  name: string
  alpha_3: string
  order: number | null
}

export interface CountryFilters {
  is_eu_member?: boolean
}

export interface BeneficialOwner {
  readonly id: number | null
  first_name: string
  last_name: string
  country_of_residence: string | number
  id_code: string
  is_politically_exposed: boolean
  is_board_member: boolean
  percentage: number | string
}

export interface ServiceTemplate {
  template: Template
}

export interface Template {
  readonly id?: number
  title: string
  content: string
  timings: Timing[]
  services: number[]
  send_retroactively: boolean
  restriction_check_in_done: boolean
  restriction_check_in_undone: boolean
  type: ServiceType | undefined
}

export interface ServiceTemplate extends Template {
  isSelected: boolean
}

export interface ServiceTemplateResponse {
  template_services: Template[]
}

export interface ServiceTempatePayload {
  template_ids: number[]
}

export interface Timing {
  readonly id: number
  name: string
}

export interface TemplateVariable {
  readonly id: number
  key: string
  name: string
}

export interface CheckInQuestion {
  readonly id?: number
  question: string
  company: number | null
  services: number[]
}

export interface ActivatePropertyPayload {
  agreed_at: boolean
}

export interface ActivateRoomsPayload {
  agreed_at: boolean
  service_relations: ServiceRelation[]
}

export interface MappedService {
  myRoomId: number
  roomId: string
}

export interface ServiceRelation {
  booking_room: string
  company_relation?: number
  service?: number
}

export interface Contract {
  readonly id?: number
  name: string
  content: string
  services: string[]
  archived_services: number
  client_consents: number
  updated_at: StringDateTime | null
  archived_at: StringDateTime | null
}

export interface CompanyRole {
  readonly id?: number
  name: string
  permissions: PERMISSIONS[]
}

export interface Permission {
  name: PERMISSIONS
}

export interface CompanyNotification {
  key: COMPANY_NOTIFICATIONS
  label: string
  description: string
  sendEmail: boolean
}

export interface CompanyNotificationResponse {
  order_paid: boolean
  reservation_cancelled: boolean
  event_cancelled: boolean
  event_cancellation_delayed: boolean
  event_cancellation_passed: boolean
  partnership_invite_response: boolean
  partnership_status_change: boolean
  partnership_payout_percentage_change: boolean
}

export type CompanyNotificationPayload = {
  [field in COMPANY_NOTIFICATIONS]: boolean
}

export interface TabPayload {
  tab: SETTINGS_TABS
  label: string
  activeComponent: Component
  route: ROUTE_PATHS
  isRouterView?: boolean
  subTabs?: Ref<TabPayload[]>
}

export interface ColorPreferences {
  primary: string
  primary_dark: string
  primary_light: string
  primary_light_1: string
  primary_light_2: string
  secondary: string
  secondary_dark: string
  secondary_light: string
  secondary_dark_text: string
  secondary_light_text: string
  secondary_text: string
}

export const COLORS = {
  primary: '#35D152',
  primary_dark: '#009E21',
  primary_light: '#74FF82',
  primary_light_1: '#A3FFAC',
  primary_light_2: '#D7FFDB',
  secondary_dark: '#0011A8',
  secondary: '#0022DB',
  secondary_light_1: '#D8DFFF',
  secondary_dark_text: '#FFFFFF',
  secondary_light_text: '#00000',
  secondary_text: '#FFFFFF',
}
